import { regulatedCompanyNavigation, webapp, domainEUUrl } from 'config';
import React, {useEffect, useState} from "react";
import {DarwinexLogoWhite} from "src/components/icons/DarwinexLogoWhite";
import {IconArrow} from "src/components/icons/IconArrow";
import classNames from "classnames";
import {useTranslationService} from "src/services/TranslationService";
import styles from "src/components/auth/Auth.module.scss";
import {getLooserUsersPercentage} from "../../api/commons";
import {regulatedCompaniesEnum} from "../../enums/regulated-companies";

const HOME_PAGE = '/';

const onGoUrl = (url) => {
    let urlDestination = HOME_PAGE;
    if (url) {
        urlDestination = url;
    } else if (window.history.length > 1) {
        try {
            const urlReferrer = document.referrer;
            urlDestination = typeof urlReferrer !== 'undefined' && (urlReferrer.includes(webapp) || urlReferrer.includes(domainEUUrl)) ? urlReferrer : HOME_PAGE;
        } catch (errorReferrer) {
            urlDestination = HOME_PAGE
        }
    }
    location.href = urlDestination;
}

export const AuthLayout = ({children, signUp = false, url = null}) => {
    const {t} = useTranslationService();

    const [looserUsersPercentage , setLooserUsersPercentage] = useState('---');

    useEffect(() => {
        getLooserUsersPercentage().then((response) => {
            setLooserUsersPercentage(Math.floor(response));
        });
    }, []);

    return (
        <article className={classNames("theme-light", styles.layout, signUp && styles.signUp)}>
            <header className={styles.header}>
                <div className={styles.go_back} onClick={() => onGoUrl(url)}>
                    <IconArrow rotation={"left"}></IconArrow>
                </div>
                <DarwinexLogoWhite/>
                <div>&nbsp;</div>
            </header>
            <main className={classNames(styles.body)}>
                {children}
            </main>
            { regulatedCompanyNavigation !== regulatedCompaniesEnum.DX_SYC && <footer className={styles.footer}>
                {t('new-login.footer', {
                    looserUsersPercentage,
                })}
            </footer> }
        </article>
    );
};
